import Header from "../components/header";
import PageTitle from "../components/page-title";
import { requestPasswordReset } from "../functions/requestPasswordReset";
import ConfirmPasswordModule from "../components/confirm-password";

function ConfirmPassword(){  
    const handleClick =() => {
        window.location.href = "/login"
    }
    return <>
    <Header CTA='Log in' functionForButton={handleClick}></Header>
    <ConfirmPasswordModule></ConfirmPasswordModule>
    </>
}
    
export default ConfirmPassword;